import { useEffect } from "react";
import { viewmodeUI } from "../../../App";
import useUIBp from "../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../store/slices/UI";
import { currentGroupnameId } from "../../GroupsTraveler/Actions/loadGroupsTree";
import BasicLayout from "../../UI/BasicLayout/BasicLayout";
import { resetScrollId } from "../../UI/BasicLayout/Components/Core/Core";
import { defaultSort } from "../../UI/GeneralPurpose/genericIDs";
import {
  connectionColumnID,
  devicesColumnID,
  groupColumnID,
  lastBackupColumnID,
  lastSentColumnID,
  nameColumnID,
  sizeColumnID,
  stateColumnID,
  uploadColumnID,
  versionColumnID,
} from "../Dialogs/ToggleReportColumns/Components/ColumnsList/ColumnsList";
import headersData from "./Headers";
import PlusActions, { plusActionsGrid } from "./PlusActions/PlusActions";
import ReportRow from "./ReportRow/ReportRow";

const Core = ({ devices, allDevices, done, working, error, workerId }) => {
  const { dispatch, auth, settings, UI } = useUIBp();
  const viewmode = UI[viewmodeUI] ?? "desktop";
  const groupname = UI[currentGroupnameId];
  const showNameColumn = UI[nameColumnID] ?? true;
  const showDeviceColumn = UI[devicesColumnID] ?? true;
  const showGroupColumn = UI[groupColumnID] ?? false;
  const showSizeColumn = UI[sizeColumnID] ?? true;
  const showLastBackupColumn = UI[lastBackupColumnID] ?? true;
  const showLastSentColumn = UI[lastSentColumnID] ?? true;
  const showUploadColumn = UI[uploadColumnID] ?? true;
  const showVersionColumn = UI[versionColumnID] ?? true;
  const showConnectionColumn = UI[connectionColumnID] ?? true;
  const showStateColumn = UI[stateColumnID] ?? true;
  const sort = UI[defaultSort] ?? { value: "user" };

  // console.log("showGroupColumn", showGroupColumn);
  useEffect(() => {
    // console.log("Core useEffect: sort.value", sort.value);
    // console.log("Core useEffect: showNameColumn", showGroupColumn);
    if (sort.value === "name" && !showNameColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "device" && !showDeviceColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "group" && !showGroupColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "space_active" && !showSizeColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "lastBkp" && !showLastBackupColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "lastChanges" && !showLastSentColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "bandwidth" && !showUploadColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "croppedVersion" && !showVersionColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "connected" && !showConnectionColumn) dispatch(UIactions.clear(defaultSort));
    if (sort.value === "status" && !showStateColumn) dispatch(UIactions.clear(defaultSort));

    dispatch(UIactions.setValue({ id: resetScrollId, value: true }));
  }, [
    dispatch,
    showNameColumn,
    showDeviceColumn,
    showGroupColumn,
    showSizeColumn,
    showLastBackupColumn,
    showLastSentColumn,
    showUploadColumn,
    showVersionColumn,
    showConnectionColumn,
    showStateColumn,
    sort.value,
  ]);

  const UIText = {
    "es-CL": `Reporte del grupo ${groupname}`,
    "en-US": `Report from group ${groupname}`,
  };
  const header = UIText[settings.locale];
  const plusActions = <PlusActions />;

  const elements = devices.map((data, idx) => <ReportRow key={idx} {...data} />);

  let fixedWidth;

  if (viewmode === "compact") {
    fixedWidth = "100vw";
  } else if (viewmode === "verycompact") {
    fixedWidth = "125vw";
  } else if (viewmode === "mobile") {
    fixedWidth = "250vw";
  }

  const coreData = {
    working,
    error: {
      workerId,
      error,
      UIText: {
        "es-CL": {
          message: "Error al cargar el reporte: " + error,
        },
        "en-US": { message: "Error loading the report: " + error },
      },
    },
    empty: {
      isEmpty: !devices.length && done && !error,
      UIText: {
        "es-CL": { message: "No hay items disponibles en el reporte" },
        "en-US": { message: "There are no available items on the report" },
      },
    },
    done,
    elements,
  };

  const filteredHeadersData = {
    headers: [],
  };

  if (showNameColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === nameColumnID));
  if (showDeviceColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === devicesColumnID));
  if (showGroupColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === groupColumnID));
  if (showSizeColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === sizeColumnID));
  if (showLastBackupColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === lastBackupColumnID));
  if (showLastSentColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === lastSentColumnID));
  if (showUploadColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === uploadColumnID));
  if (showVersionColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === versionColumnID));
  if (showConnectionColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === connectionColumnID));
  if (showStateColumn) filteredHeadersData.headers.push(headersData.headers.find((h) => h.id === stateColumnID));

  return (
    <BasicLayout
      {...{
        plusActions,
        plusActionsGrid,
        header,
        headersData: filteredHeadersData,
        fullArray: auth.admin === 1 ? allDevices : undefined,
        coreData,
        overflowX: viewmode === "desktop" ? "hidden" : "auto",
        fixedWidth,
        onPaginationChange: () => {
          dispatch(UIactions.setValue({ id: resetScrollId, value: true }));
        },
      }}
    />
  );
};

export default Core;
